module.exports = __webpack_public_path__ + "static/assets/b0820e78fa6c0cd7fbdf4a7f73fd84d2.png";